export const environment = {
    production: true,
    MIN_LOG_LEVEL: 2, //INFO LEVEL
    siteKey: '6LekvIMUAAAAAJeIghV28i_hgG8ANgxNqznk3Kkf',
};
